import { ReactNode, lazy } from "react"
import { INewsMessage } from "store/apis/infoModalsAPI/types"

export const COMMON_MODALS = {
  globalError: {
    component: lazy(() => import("modals/ui/common/GlobalError")),
    inRouter: false
  },
  pageLoading: {
    component: lazy(() => import("modals/ui/common/Loader")),
    inRouter: false
  },
  linkExpired: {
    component: lazy(() => import("modals/ui/common/LinkExpired"))
  },
  happyHourDetails: {
    component: lazy(() => import("modals/ui/common/HappyHourDetails"))
  },
  confirm: {
    component: lazy(() => import("modals/ui/common/Confirm")),
    params: {} as {
      body?: ReactNode
      onCancel?: () => any
      onConfirm?: () => any
    }
  },
  newsFeed: {
    component: lazy(() => import("modals/ui/common/NewsFeedModal")),
    params: {} as {
      message: INewsMessage
    }
  },
  newsMine: {
    component: lazy(() => import("modals/ui/common/NewsMineModal"))
  },
  onboarding: {
    component: lazy(() => import("modals/ui/common/Onboarding"))
  },
  terms: {
    component: lazy(() => import("modals/ui/common/terms-of-use"))
  },
  privacy: {
    component: lazy(() => import("modals/ui/common/privacy-policy"))
  },
  aml: {
    component: lazy(() => import("modals/ui/common/aml"))
  },
  vipPass: {
    component: lazy(() => import("modals/ui/common/vip-pass-modal"))
  },
  vipPassPriceInfo: {
    component: lazy(() => import("modals/ui/common/vip-pass-price-info"))
  },
  pageLoadingError: {
    component: lazy(() => import("modals/ui/common/loadPageErrorModal"))
  },
  spinWealModal: {
    component: lazy(() => import("modals/ui/common/SpinWheelModal"))
  },
  buyElixir: {
    component: lazy(() => import("modals/ui/common/BuyElixir")),
    params: {} as {
      selectedElixir: any
      recyclesShown?: number
      uniqueElixirId?: string
      hideFavorite?: boolean
    }
  },
  elixirDetails: {
    component: lazy(() => import("modals/ui/common/ElixirDetails")),
    params: {} as {
      selectedElixir: any
      recyclesShown?: number
    }
  },
  buyGenesisPreform: {
    component: lazy(() => import("modals/ui/common/BuyGenesisPreform")),
    params: {} as {
      countToBuy: number
    }
  },
  auctionElixirBuy: {
    component: lazy(() => import("modals/ui/common/auction-elixir-buy")),
    params: {} as {}
  }
} as const
